import React, { Component } from "react";
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import moment from 'moment';
import Moment from 'react-moment';
import {
  Row,
  Alert,
  Badge,
  Button,
  ButtonGroup
} from "reactstrap";
import { dashboardSinhNhatListRequest } from './actions'
import * as constants from './constants'
import { storedb } from '../../views/client/storedb'
import Stats from '../../components/Stats/Stats'
import Chart from '../../components/Chart/Chart'
import Chart2 from '../../components/Chart2/Chart2'
import Pagination from "react-js-pagination";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      store_id: dbContext.getStoreId(),
      tuNgay: moment().startOf('month'),
      denNgay: moment().endOf('month'),
      toDay: moment(),
      item: {},
      list: [],
      DataSinhNhat: {
        sinhnhat: [],
        countSinhNhat1: 0,
        countSinhNhat2: 0,
        countSinhNhat3: 0,
        countSinhNhat4: 0,
      },
      page: 1,
      per_page: 10,
      rSelected: 0
    };
    this.onRadioBtnClick = this.onRadioBtnClick.bind(this);
  }
  viewOrderReport = (e, item) => {
    e.preventDefault()
    this.props.history.push('/order-report?kh=' + item.Id + "&ql=" + item.IdQuanLy);
  };
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1);
    const { rSelected } = this.state;
    this.setState({ page }, () => {
      if (rSelected == 0) {
        return this.LoadDataSinhNhatDashBoard(moment());
      } else {
        return this.LoadDataSinhNhatDashBoard(moment().add('days', rSelected));
      }
    });
  }
  onRadioBtnClick(rSelected) {
    this.setState({ rSelected, page: 1 }, () => {
      if (rSelected == 0) {
        this.LoadDataSinhNhatDashBoard(moment());
      } else {
        this.LoadDataSinhNhatDashBoard(moment().add('days', rSelected));
      }
    });
  }
  componentDidMount() {
    this.LoadDataSinhNhatDashBoard(this.state.toDay)
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.dashboard.type == constants.DASHBOARD_SINHNHAT_LIST_SUCCESS) {
      let { list, } = nextProps.dashboard;
      const {DataSinhNhat} = this.state
      if(list){
        DataSinhNhat.sinhnhat = list.sinhnhat || [];
        DataSinhNhat.countSinhNhat1 =  list.countSinhNhat1 || 0
        DataSinhNhat.countSinhNhat2 =  list.countSinhNhat2 || 0
        DataSinhNhat.countSinhNhat3 =  list.countSinhNhat3 || 0
        DataSinhNhat.countSinhNhat4 =  list.countSinhNhat4 || 0
      }
      this.setState({ DataSinhNhat });
    }
  }
  LoadDataSinhNhatDashBoard = (tuNgay) => {
    const { dashboardSinhNhatListRequest } = this.props
    var requestData = {
      tu_ngay: tuNgay.format('YYYYMMDD'),
      to_day: this.state.toDay.format('YYYYMMDD'),
      store_id: this.state.store_id,
      page: this.state.page,
      per_page: this.state.per_page
    }
    return dashboardSinhNhatListRequest(requestData)
  }
  formatNumber = (val) => { return parseFloat(val || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 }) }
  formatDate = (val) => { return val ? val.format('DD/MM/YYYY') : ""; }

  render() {
    const { DataSinhNhat } = this.state;
    const {
      dashboard: {
        listRequesting
      },
    } = this.props;
    return (
      <div className="animated fadeIn">
        <Row>
          <Stats
            {...this.props}
            tu_ngay={this.state.tuNgay.format('YYYYMMDD')}
            den_ngay={this.state.denNgay.format('YYYYMMDD')}
            store_id={this.state.store_id}
            to_day={this.state.toDay.format('YYYYMMDD')}
          >
          </Stats>
        </Row>
        <BlockUi tag="div" blocking={listRequesting} >
          <Row className="mt-2">
            <div className="col">
              <Alert color="primary" style={{ padding: 5 }} className="mb-0">
                <i className="fa fa-gift"></i> LỊCH CHĂM SÓC SINH NHẬT KHÁCH HÀNG
              </Alert>
              <ButtonGroup className="mt-2 mb-2">
                <Button color="success" className="mr-2" onClick={() => this.onRadioBtnClick(0)} active={this.state.rSelected === 0}>
                  <i className="fa fa-calendar text-white"></i> {moment().format("DD/MM/YYYY")} <Badge color="danger">{DataSinhNhat.countSinhNhat1 || 0}</Badge>
                </Button>
                <Button color="success" className="mr-2" onClick={() => this.onRadioBtnClick(1)} active={this.state.rSelected === 1}>
                  <i className="fa fa-calendar text-white"></i> {moment().add('days', 1).format("DD/MM/YYYY")} <Badge color="danger">{DataSinhNhat.countSinhNhat2 || 0}</Badge>
                </Button>
                <Button color="success" className="mr-2" onClick={() => this.onRadioBtnClick(2)} active={this.state.rSelected === 2}>
                  <i className="fa fa-calendar text-white"></i> {moment().add('days', 2).format("DD/MM/YYYY")} <Badge color="danger">{DataSinhNhat.countSinhNhat3 || 0}</Badge>
                </Button>
                <Button color="success" className="mr-2" onClick={() => this.onRadioBtnClick(3)} active={this.state.rSelected === 3}>
                  <i className="fa fa-calendar text-white"></i> {moment().add('days', 3).format("DD/MM/YYYY")} <Badge color="danger">{DataSinhNhat.countSinhNhat4 || 0}</Badge>
                </Button>
              </ButtonGroup>
              <div className="table-responsive">
                <table className="table table-sm table-bordered table-striped table-hover mb-1">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Tên</th>
                      <th>Địa chỉ</th>
                      <th>Thành phố</th>
                      <th>Điện thoại</th>
                      <th>Trình dược viên</th>
                      <th>Ngày sinh</th>
                    </tr>
                  </thead>
                  <tbody>
                    {DataSinhNhat.sinhnhat && !!DataSinhNhat.sinhnhat.length && (
                      DataSinhNhat.sinhnhat.map((res, idx) => (
                        <tr key={idx + 1}>
                          <td className="text-center">{idx + 1}</td>
                          <td className="text-left"><a href='#' onClick={(e) => this.viewOrderReport(e, res)}>{res.Ten}</a> </td>
                          <td className="text-left">{res.DiaChi}</td>
                          <td className="text-left">{res.RegionName}</td>
                          <td className="text-left">{res.DienThoai}</td>
                          <td className="text-left">{res.TenQuanLy}</td>
                          <td className="text-left">{res.NgaySinh ? <Moment format="DD/MM/YYYY">{`${res.NgaySinh}`}</Moment> : ""}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
                {DataSinhNhat.totalRecord > DataSinhNhat.per_page && (
                  <Pagination
                    activePage={this.state.page}
                    itemsCountPerPage={this.state.per_page}
                    totalItemsCount={DataSinhNhat.totalRecord}
                    pageRangeDisplayed={5}
                    onChange={this.handlePageChange}
                  />
                )}
              </div>
            </div>
          </Row>
        </BlockUi>
        <Row>
          <div className="col-sm-6">
            <Chart
              tu_ngay={this.state.tuNgay.format('YYYYMMDD')}
              den_ngay={this.state.denNgay.format('YYYYMMDD')}
              store_id={this.state.store_id}
              to_day={this.state.toDay.format('YYYYMMDD')}
              title="Doanh số bán hàng ngày"
              type={1}
            >
            </Chart>
          </div>
          <div className="col-sm-6">
            <Chart2
              tu_ngay={this.state.tuNgay.format('YYYYMMDD')}
              den_ngay={this.state.denNgay.format('YYYYMMDD')}
              store_id={this.state.store_id}
              to_day={this.state.toDay.format('YYYYMMDD')}
              title="Doanh số bán hàng tháng"
              type={2}
            >
            </Chart2>
          </div>
        </Row>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  dashboard: state.dashboard
})

const connected = connect(mapStateToProps, {
  dashboardSinhNhatListRequest
})(Dashboard)

const formed = reduxForm({
  form: 'dashboard',
})(connected)

export default formed;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.js